export const queryKeys = {
  customizations: {
    all: ["customizations"] as const,
    default: ["customizations", "default"] as const,
  },
  customCodeActions: {
    all: ["customCodeActions"] as const,
    byId: (codeActionId: number) => ["customCodeActions", codeActionId] as const,
  },
  environments: {
    all: ["environments"] as const,
    pushedTemplateIds: ["environments", "pushed-template-ids"] as const,
  },
  eventWebhooks: {
    all: ["eventWebhooks"] as const,
  },
  fileFeeds: {
    all: ["fileFeeds"] as const,
    byWorkspace: (workspaceId: number) =>
      ["fileFeeds", "byWorkspace", { workspaceId }] as const,
  },
  fileFeedEventWebhooks: {
    all: ["fileFeedEventWebhooks"] as const,
  },
  fileFeedImportWebhooks: {
    all: ["fileFeedImportWebhooks"] as const,
  },
  importerWebhooks: {
    all: ["importerWebhooks"] as const,
  },
  pipelines: {
    all: ["pipelines"] as const,
    byId: (pipelineId: number) => ["pipelines", pipelineId] as const,
    promptGeneratedCodeActions: (pipelineId: number) =>
      ["pipelines", pipelineId, "prompt-generated-code-actions"] as const,
  },
  sftpAccounts: {
    all: ["sftpAccounts"] as const,
  },
  templates: {
    all: ["templates", "all"] as const,
    byId: (templateId: number) => ["templates", { id: templateId }] as const,
    skeletons: ["templates", "skeletons"] as const,
    viewData: ["templates", "view-data"] as const,
  },
  workspaces: {
    all: ["workspaces"] as const,
    viewData: ["workspaces", "view-data"] as const,
  },
} as const
